import * as React from "react";
import { ImageList } from "@material-ui/core";
import { ImageListItemBar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { linkToRecord, NumberField, useListContext } from "react-admin";
import { Link } from "react-router-dom";
import { ImageListItem } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    gridList: {
        margin: 0,
    },
    tileBar: {
        background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.4) 70%,rgba(0,0,0,0) 100%)",
    },
    placeholder: {
        backgroundColor: theme.palette.grey[300],
        height: "100%",
    },
    price: {
        display: "inline",
        fontSize: "1em",
    },
    link: {
        color: "#fff",
    },
}));

const getColsForWidth = (width) => {
    if (width === "xs") return 2;
    if (width === "sm") return 3;
    if (width === "md") return 3;
    if (width === "lg") return 5;
    return 6;
};

const times = (nbChildren, fn) => Array.from({ length: nbChildren }, (_, key) => fn(key));

const LoadingGridList = (props) => {
    const { width, nbItems = 20 } = props;
    const classes = useStyles();
    return (
        <ImageList rowHeight={180} cols={getColsForWidth(width)} className={classes.gridList}>
            {" "}
            {times(nbItems, (key) => (
                <ImageListItem key={key}>
                    <div className={classes.placeholder} />
                </ImageListItem>
            ))}
        </ImageList>
    );
};

const LoadedGridList = (props) => {
    const { width } = props;
    const { ids, data, basePath } = useListContext();

    const classes = useStyles();

    if (!ids || !data) return null;

    return (
        <ImageList rowHeight={180} cols={getColsForWidth(width)} className={classes.gridList}>
            {ids.map((id) => (
                <ImageListItem
                    // @ts-ignore
                    component={Link}
                    key={id}
                    to={linkToRecord(basePath, data[id].id)}
                >
                    
                    <img src={data[id].images[0] ? data[id].images[0] : "https://www.generationsforpeace.org/wp-content/uploads/2018/07/empty.jpg"} alt="" />
                    <ImageListItemBar
                        className={classes.tileBar}
                        title={data[id].name}
                        subtitle={
                            <span>
                                {data[id].width}x{data[id].height},{" "}
                                <NumberField
                                    className={classes.price}
                                    source="daily_rent_price"
                                    record={data[id]}
                                    color="inherit"
                                    options={{
                                        style: "currency",
                                        currency: "USD",
                                    }}
                                />
                                $
                            </span>
                        }
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
};

const GridList = (props) => {
    const { width } = props;
    const { loaded } = useListContext();
    return loaded ? <LoadedGridList width={width} /> : <LoadingGridList width={width} />;
};

export default GridList;
